import { LogOut } from 'lucide-react'

import { useAuth, useAuthActions } from '@/hooks/use-auth'

/**
 * Sticky top header — brand mark, driver name greeting, logout
 * button.
 *
 * Static height so the bottom-nav can compute its safe area
 * without measuring (`h-14` = 56px). The greeting falls back to
 * the email if the JWT-decoded user has no `name` (which happens
 * after a refresh-on-boot — the name is only learned at login
 * time).
 */
export function Header() {
  const { user } = useAuth()
  const { logout } = useAuthActions()

  const display = user?.name ?? user?.email ?? 'Chauffeur'
  const firstName = display.split(' ')[0] ?? display

  return (
    <header
      className={[
        'sticky top-0 z-10',
        'h-14 px-4',
        'bg-brand text-brand-fg',
        'flex items-center justify-between',
        'shadow-sm',
      ].join(' ')}
    >
      <div className="flex items-baseline gap-2">
        <span className="text-lg font-bold">Avity</span>
        <span className="text-sm opacity-90 truncate max-w-[180px]">
          Bonjour {firstName}
        </span>
      </div>
      <button
        type="button"
        onClick={() => logout()}
        aria-label="Se déconnecter"
        className={[
          'inline-flex items-center justify-center',
          'min-h-[2.5rem] min-w-[2.5rem] rounded-lg',
          'hover:bg-brand-strong active:bg-brand-strong',
          'transition-colors duration-100',
          'focus-visible:outline-none focus-visible:ring-2 focus-visible:ring-brand-fg focus-visible:ring-offset-2 focus-visible:ring-offset-brand',
        ].join(' ')}
      >
        <LogOut size={20} aria-hidden="true" />
      </button>
    </header>
  )
}
